export const lightColors = {
  text: {
    primary: '#333333',
    secondary: '#858585',
    tertiary: '#B5B5B5',
    specialSecondary: '#6B6B6B',
    white: '#FFFFFF',
    green: '#00AB6B',
    red: '#EE4A49',
    orange: '#F5931B',
    periwinkle: '#8277F8',
    purple: '#8250A3',
    violet: '#9343C8',
    liberty: '#6159B8',
  },
  artboard: {
    surfaceDefault: '#FFFFFF',
    surfaceVariant: '#F7F7F7',
    surfaceEmphasis: '#F7F7F7',
    surfaceHighlight: '#F2F2F2',
    dividerThin: '#F1F1F1',
    dividerThick: '#F7F7F7',
    border: '#EDEDED',
    borderGreen: '#0BA16B',
    borderRed: '#EE4A49',
    borderOrange: '#F5931B',
    borderPeriwinkle: '#8277F8',
  },
  modals: {
    surfaceDefault: '#FFFFFF',
    surfaceEmphasis: '#F7F7F7',
    surfaceHighlight: '#F2F2F2',
    dividerThin: '#F1F1F1',
    dividerThick: '#F7F7F7',
    border: '#EDEDED',
    borderGreen: '#0BA16B',
    borderRed: '#D74342',
    borderOrange: '#E4830C',
    borderPeriwinkle: '#796FEC',
  },
  icon: {
    default: '#969696',
    lowerEmphasis: 'rgba(150, 150, 150, 0.6)',
    white: '#FFFFFF',
    green: '#0BA16B',
    red: '#D74342',
    orange: '#E4830C',
    periwinkle: '#796FEC',
  },
  semantic: {
    inactive: '#CBCBCB',
    active: '#00AB6B',
    error: '#EE4A49',
    warning: '#F5931B',
    informative: '#8277F8',
  },
  peach: {
    low: '#FBF0F0',
    medium: '#F7E1E0',
    default: '#D96A65',
  },
  red: {
    low: '#FDEDED',
    medium: '#FBDFDF',
    default: '#EE4A49',
  },
  orange: {
    low: '#322311',
    medium: '#422C11',
    default: '#E4830C',
  },
  yellow: {
    low: '#352B14',
    medium: '#4C3C15',
    default: '#FCBC1D',
  },
  brown: {
    low: '#2C241B',
    medium: '#3A2D20',
    default: '#966B40',
  },
  olive: {
    low: '#222617',
    medium: '#30361D',
    default: '#89A23F',
  },
  green: {
    low: '#EBF8F3',
    medium: '#CCEEE1',
    default: '#0BA16B',
  },
  turqoise: {
    low: '#093029',
    medium: '#10564A',
    default: '#35CBB1',
  },
  teal: {
    low: '#112925',
    medium: '#0F4138',
    default: '#09AE91',
  },
  navy: {
    low: '#1A212D',
    medium: '#1C2537',
    default: '#34518D',
  },
  cobalt: {
    low: '#14222B',
    medium: '#162D3D',
    default: '#2073AC',
  },
  blue: {
    low: '#19262E',
    medium: '#203846',
    default: '#439ACB',
  },
  periwinkle: {
    low: '#1E1D2C',
    medium: '#2D2A4B',
    default: '#796FEC',
  },
  violet: {
    low: '#1F1527',
    medium: '#281634',
    default: '#8228BD',
  },
  purple: {
    low: '#221B27',
    medium: '#32233C',
    default: '#7E4B9F',
  },
  pink: {
    low: '#281A25',
    medium: '#43253A',
    default: '#E65BBF',
  },
  magenta: {
    low: '#231421',
    medium: '#30152C',
    default: '#861D75',
  },
} as const;
